import { useState, useEffect, ReactNode } from 'react'

import { useLocation } from 'react-router'

import { ThemeContext, INITIAL_STATE, ThemeState } from './themeContext'

import ThemeHelper from 'common/helpers/theme'

interface Props {
  children: ReactNode,
  state?: ThemeState
}

const ThemeProvider = ({ children, state }: Props) => {
  const [darkMode, setDarkMode] = useState(INITIAL_STATE.darkMode)

  const { search } = useLocation()

  useEffect(() => {
    setDarkMode(ThemeHelper.isDarkMode(search))
  }, [search])

  return (
    <ThemeContext.Provider value={{
      darkMode,
      ...state
    }}>
      {children}
    </ThemeContext.Provider>
  )
}

export default ThemeProvider
